import { useState, type FormEvent } from 'react';
import './Login.css';

interface Props {
  onSuccess: () => void;
}

export function Login({ onSuccess }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        onSuccess();
        return;
      }
      if (res.status === 429) {
        setError('Too many attempts. Wait a while.');
      } else {
        setError('Incorrect.');
      }
    } catch {
      setError("Something amiss upstream. Try again shortly.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-main">
      <form onSubmit={handleSubmit} className="login-form">
        <h1 className="login-title">bilbo</h1>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
          autoFocus
          autoComplete="current-password"
          className="login-input"
        />
        {error && <p className="login-error">{error}</p>}
        <button
          type="submit"
          disabled={submitting || !password}
          className="login-submit"
        >
          {submitting ? '…' : 'Enter'}
        </button>
      </form>
    </main>
  );
}
